<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-col class="com-mb-graph pa-0" ref="cctvBox">
        <v-row class="com-mb-card-header">
          <span class="com-mb-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-row no-gutters class="com-mb-card-contents ma-2">
          <v-col>
            <tm-scam id="tmCctv" :isDlg="true"></tm-scam>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]簡易カメラダイアログ
 * TmScamDlg.vue
 * @author ILUKE
 */

import TmScam from "./TmScam.vue";

export default {
  name: "tm-scam-dlg",
  components: {
    TmScam,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "簡易カメラ",
      },
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    cctvType: {
      get() {
        return this.$store.state.sns.postCamera;
      },
    },
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.cctvBox !== undefined) {
          const offsetWidth = this.$refs.cctvBox.offsetWidth;
          const offsetHeight = this.$refs.cctvBox.offsetHeight;
          var cctvItem = document.getElementById("tmCctv");
          if (
            offsetWidth > 0 &&
            offsetHeight > 0 &&
            offsetWidth > offsetHeight
          ) {
            if (this.cctvType === "live") {
              cctvItem.style.paddingLeft = "130px";
              cctvItem.style.paddingRight = "130px";
            } else {
              cctvItem.style.paddingLeft = "175px";
              cctvItem.style.paddingRight = "175px";
            }
          } else {
            cctvItem.style.paddingLeft = "0px";
            cctvItem.style.paddingRight = "0px";
          }
        }
      });
    },
  },
  watch: {
    cctvType() {
      this.handleResize();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
